import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at top left, #0f2027, #203a43, #2c5364)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        color: '#ffffff',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '600px' }}>
        <motion.img
          src="https://static.vecteezy.com/system/resources/previews/009/121/863/non_2x/neo-logo-neo-letter-neo-letter-logo-design-initials-neo-logo-linked-with-circle-and-uppercase-monogram-logo-neo-typography-for-technology-business-and-real-estate-brand-vector.jpg"
          alt="Neo Typer Logo"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            width: 100,
            borderRadius: '50%',
            boxShadow: '0 12px 30px rgba(22, 242, 136, 0.3)',
            marginBottom: 20,
          }}
        />
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>
          Neo <b style={{ color: '#16f288' }}>Typer</b>
        </h1>
        <p style={{ fontSize: '1.2rem', color: '#a0f5db', marginBottom: '2.5rem' }}>
          Smart Auto Typer with Verified Daily Answers.<br />
          Boost your speed and accuracy effortlessly.
        </p>
        <Link to="/login">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{
              background: '#16f288',
              color: '#000',
              padding: '14px 38px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '12px',
              boxShadow: '0 6px 22px #16f28877',
              cursor: 'pointer',
              transition: 'all 0.3s ease-in-out',
            }}
          >
            Get Started
          </motion.button>
        </Link>
      </div>
    </motion.div>
  );
}
